/*** IMPORTS FROM imports-loader ***/
var define = false;

const BackButton = {
  init: function() {
    const buttonEl = document.querySelector('a.back');
    if (buttonEl) {
      buttonEl.addEventListener('click', function(evt) {
        evt.preventDefault();
        if (document.referrer && document.referrer !== location.href) {
          history.back();
        } else {
          location.href = buttonEl.href;
        }
      })
    }
  },
}

export default BackButton;

